import { render } from "./UpdateBlog.vue?vue&type=template&id=36639bba"
import script from "./UpdateBlog.vue?vue&type=script&lang=js"
export * from "./UpdateBlog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__